module.exports = __webpack_public_path__ + "img/s4-3.b16673a7.svg";